var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#61656C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.473 22.283l7.701-7.46 9.636 8.298-.652.758-8.945-7.703-7.044 6.825z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.19 26.121l9.61-8.275 9.1 7.518-.637.77-8.45-6.981-8.971 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.984 4H.016v27h31.968V4zm-1.001 1v25H1.016V5h29.967z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.452 9c-1.698 0-3.081 1.34-3.081 3s1.383 3 3.08 3c1.699 0 3.081-1.34 3.081-3s-1.382-3-3.08-3zm0 1c1.152 0 2.08.899 2.08 2s-.928 2-2.08 2c-1.153 0-2.081-.899-2.081-2s.928-2 2.08-2z"
  }))));
}
export default SvgPlaceholderImage;